<template>
  <div class="countdown-circle">
    <svg
      class="countdown-circle__svg"
      width="40"
      height="40"
    >
      <defs>
        <linearGradient
          id="gradient"
          x1="0%"
          y1="0%"
          x2="100%"
          y2="100%"
        >
          <stop
            offset="30%"
            :style="{ stopColor: startColor, stopOpacity: 1 }"
          />
          <stop
            offset="100%"
            :style="{ stopColor: endColor, stopOpacity: 1 }"
          />
        </linearGradient>
      </defs>
      <circle
        class="countdown-circle__progress"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="progressOffset"
        r="15"
        cx="20"
        cy="20"
        fill="transparent"
        :stroke-width="strokeWidth"
        stroke="url(#gradient)"
      />
      <text
        class="countdown-circle__text"
        x="50%"
        y="52%"
        text-anchor="middle"
        dominant-baseline="middle"
      >
        {{ formattedTimeRemaining }}
      </text>
    </svg>
    <md-tooltip md-direction="bottom">
      Tempo restante da sessão após inatividade
    </md-tooltip>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CountdownCircle',
  computed: {
    ...mapGetters(['inactivityLimit', 'formattedTimeRemaining', 'timeRemainingInMilliseconds']),
    circumference() {
      return 2 * Math.PI * 15
    },
    progressOffset() {
      const totalTime = this.inactivityLimit
      const remainingTime = this.timeRemainingInMilliseconds
      return this.circumference * (1 - remainingTime / totalTime)
    },
    strokeWidth() {
      return 2
    },
    startColor() {
      return '#840051'
    },
    endColor() {
      return '#f2994a'
    }
  }
}
</script>


<style lang="scss" scoped>
.countdown-circle {
  width: 40px;
  height: 40px;

  &__progress {
    transition: stroke-dashoffset 0.3s ease;
  }

  &__text {
    font-family: 'Exo 2', sans-serif !important;
    font-size: 10px;
    fill: #333;
  }
}
</style>
